<template>
  <page-outline :title="titleLabel"
    iconFA="address-book">

    <template slot="pageContent">
      <fieldset v-if="type === '1'">
        <legend class="sr-only">{{ $t('administration.company_information') }}</legend>
        <b-row class="justify-content-start">
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="companyName" isMandatory
              :inputLabel="$t('administration.company_name')" :placeholderValue="$t('administration.company_name')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="companyNumber" isMandatory
              :inputLabel="$t('administration.company_number')" :placeholderValue="$t('administration.company_number')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="companyEmail" isMandatory
              :inputLabel="$t('administration.company_email')" :placeholderValue="$t('administration.company_email')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input isMandatory
              :inputLabel="$t('administration.country')"
              inputType="listeSelect"
              id="country-select-group-company">
              <select class="form-control" readonly v-model="selectedCountry" 
                      id="country-select-group-company-data"
                      :aria-required="true"
                      :aria-describedby="selectedCountry === '' ? 'country-company-error' : null"
                      :aria-invalid="selectedCountry === '' ? 'true' : 'false'">
                <option value="">{{ $t('administration.country_select') }}</option>
                <option v-for="country in countries" :value="country" :key="country">
                  {{country}}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </fieldset>
      
      <fieldset v-if="type === '2'">
        <legend class="sr-only">{{ $t('administration.user_information') }}</legend>
        <b-row class="justify-content-start">
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="userLastName" isMandatory
              :inputLabel="$t('administration.user_last_name')" :placeholderValue="$t('administration.user_last_name')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="userFirstName" isMandatory
              :inputLabel="$t('administration.user_first_name')" :placeholderValue="$t('administration.user_first_name')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="userEmail" isMandatory
              :inputLabel="$t('administration.user_email')" :placeholderValue="$t('administration.user_email')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input isMandatory
              :inputLabel="$t('administration.country')"
              inputType="listeSelect"
              id="country-select-group-user">
              <select class="form-control" readonly v-model="selectedCountry" 
                      id="country-select-group-user-data"
                      :aria-required="true"
                      :aria-describedby="selectedCountry === '' ? 'country-user-error' : null"
                      :aria-invalid="selectedCountry === '' ? 'true' : 'false'">
                <option value="">{{ $t('administration.country_select') }}</option>
                <option v-for="country in countries" :value="country" :key="country">
                  {{country}}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </fieldset>
    </template>
    <template slot="footerButtons">
      <b-row>
        <b-col md="2" offset-md="9">
          <f7-button
            class="button-action milkyBlockBlack"
            @click="addUser">
            <f7-icon fa="save"></f7-icon>
            <span>{{ $t('common.sve') }}</span>
          </f7-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import countriesData from '@/pages/administration/data/countries.json'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'UserEdit',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  props: {
    type: {
      default: '2',
      type: String
    }
  },
  computed: {
    titleLabel () {
      if (this.type === '1') {
        return this.$t('administration.company_addition')
      } else if (this.type === '2') {
        return this.$t('administration.user_addition')
      }
    }
  },
  data: () => {
    return {
      companyEmail: '',
      companyName: '',
      companyNumber: '',
      countries: [],
      countriesData: countriesData.countries,
      country: '',
      selectedCountry: '',
      userEmail: '',
      userFirstName: '',
      userLastName: ''
    }
  },
  created () {
    for (let countryKey in this.countriesData) {
      this.countries.push(this.countriesData[countryKey].name)
    }
  },
  methods: {
    addUser () {
      if (this.type === '1') {
        if (this.companyName === '') {
          this.$f7.alert(this.$t('administration.company_name_missing'), this.$t('common.error'))
          return
        } else if (this.companyNumber === '') {
          this.$f7.alert(this.$t('administration.company_number_missing'), this.$t('common.error'))
          return
        } else if (this.companyEmail === '') {
          this.$f7.alert(this.$t('administration.company_email_missing'), this.$t('common.error'))
          return
        } else if (this.selectedCountry === '') {
          this.$f7.alert(this.$t('certificat.country_missing'), this.$t('common.error'))
          return
        }
      } else if (this.type === '2') {
        if (this.userLastName === '') {
          this.$f7.alert(this.$t('administration.last_name_missing'), this.$t('common.error'))
          return
        } else if (this.userFirstName === '') {
          this.$f7.alert(this.$t('administration.first_name_missing'), this.$t('common.error'))
          return
        } else if (this.userEmail === '') {
          this.$f7.alert(this.$t('administration.user_email_missing'), this.$t('common.error'))
          return
        } else if (this.selectedCountry === '') {
          this.$f7.alert(this.$t('certificat.country_missing'), this.$t('common.error'))
          return
        }
      } else {
        this.$f7.alert(this.$t('administration.type_error'), this.$t('common.error'))
        return
      }
      this.$f7.showPreloader(this.$i18n.t('registerPage.rgstrng'))
      let that = this
      this.$engine.firstOn().accounts.createUserAccount({
        companyName: this.companyName,
        companyNumber: this.companyNumber,
        firstName: this.userFirstName,
        lastName: this.userLastName,
        country: this.selectedCountry,
        companyEmail: this.companyEmail,
        userEmail: this.userEmail,
        type: this.type
      })
      .then(response => {
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t(that.type === '1' ? that.$i18n.t('administration.company_added_success') : that.$i18n.t('administration.user_added_success')),
          text: that.$i18n.t(that.type === '1' ? that.$i18n.t('administration.company_added_success_comment') : that.$i18n.t('administration.user_added_success_comment'))
        })
        setTimeout(function () {
          that.$f7.closeModal()
          loadPage(that, {
            url: '/administration/accounts/', force: false, ignoreCache: false
          })
        }, 2000)
      })
      .catch(error => {
        that.$f7.hidePreloader()
        errorMessageAlert(error, that, that.$i18n)
      })
    }
  }
}
</script>

<style scoped>
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

fieldset {
  border: none;
  margin: 0;
  padding: 0;
}

fieldset + fieldset {
  margin-top: 1.5rem;
}
</style>
